import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import Button from "./Button.mjs";
import Stack from "./Stack.mjs";
import InlineList from "./InlineList.mjs";
import "react";
import Heading from "./Heading.mjs";
import useThemeProps from "./useThemeProps.mjs";
import TypographyBlock from "./TypographyBlock.mjs";
import handleComponentsProp from "./handleComponentsProp.mjs";
import Box from "./Box.mjs";
import "@emotion/react";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "iwexz1",
  styles: "line-height:inherit"
} : {
  name: "196vssu-ConfirmDialog",
  styles: "line-height:inherit;label:ConfirmDialog;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function ConfirmDialog(props) {
  props = useThemeProps({
    props,
    name: "ConfirmDialog"
  });
  let {
    description,
    title,
    onConfirm,
    onDeny,
    confirmButtonProps,
    denyButtonProps,
    components,
    contentGap = 3,
    ...restProps
  } = props;
  components = handleComponentsProp(components, {
    Button
  });
  let {
    Button: Button$1
  } = components;
  return /* @__PURE__ */jsx(Box, {
    as: "section",
    "aria-labelledby": "confirm-dialog-title",
    "aria-describedby": "confirm-dialog-description",
    tabIndex: "0",
    ...restProps,
    children: /* @__PURE__ */jsxs(Stack, {
      spacing: contentGap,
      children: [/* @__PURE__ */jsx(Heading, {
        id: "confirm-dialog-title",
        variant: "h4",
        css: _ref,
        children: title
      }), /* @__PURE__ */jsx(TypographyBlock, {
        id: "confirm-dialog-description",
        elementMapping: {
          p: "description"
        },
        maxBlockMargin: contentGap,
        children: description
      }), /* @__PURE__ */jsxs(InlineList, {
        children: [/* @__PURE__ */jsx(Button$1, {
          onClick: onConfirm,
          variant: "primary",
          title: "Confirm",
          ...confirmButtonProps
        }), /* @__PURE__ */jsx(Button$1, {
          onClick: onDeny,
          variant: "secondary",
          title: "Deny",
          ...denyButtonProps
        })]
      })]
    })
  });
}
export { ConfirmDialog as default };